var _this = this;
import * as tslib_1 from "tslib";
import setIsFullOptionsShown from '../mutators/setIsFullOptionsShown';
import collectedOptions from '../config/collectedOptions';
import updateCategory from '../orchestrators/updateCategory';
import { orchestrator, action } from 'satcheljs';
import getDefaultCategory from '../utils/getDefaultCategory';
var initializeFullOptionsAction = action('initializeFullOptions', function (category, subcategory, option) { return ({
    category: category,
    subcategory: subcategory,
    option: option,
}); });
export default initializeFullOptionsAction;
export var initializeFullOptionsInternal = orchestrator(initializeFullOptionsAction, function (optionsPath) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var category, subcategory, option, categories, categoryKey, subcategoryKey;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                category = optionsPath.category, subcategory = optionsPath.subcategory, option = optionsPath.option;
                setIsFullOptionsShown(true);
                categories = collectedOptions();
                categoryKey = category || getDefaultCategory();
                subcategoryKey = subcategory || getFirstSubCategoryForCategory(categoryKey, categories);
                return [4 /*yield*/, updateCategory(categoryKey, subcategoryKey, option)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
function getFirstSubCategoryForCategory(categoryKey, categories) {
    var selectedCategory = categories.filter(function (category) { return category.key === categoryKey; })[0];
    return (selectedCategory &&
        selectedCategory.subcategories &&
        selectedCategory.subcategories[0] &&
        selectedCategory.subcategories[0].key);
}
//# sourceMappingURL=initializeFullOptions.js.map